import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/styles.less';
import 'react-image-crop/dist/ReactCrop.css';
import {Provider} from 'react-redux';
import App from './App';
import {store} from './store';
import './i18n/i18n';
import {httpClient} from './common/api/HttpClient';
import {setGlobalRequestInterceptor, setGlobalResponseInterceptor} from './common/api/HttpInterceptors';

setGlobalRequestInterceptor(httpClient);
setGlobalResponseInterceptor(httpClient);

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>
    , document.getElementById('root')
);
